import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SectionHeader } from "@pentabd/ui";

import { EMPLOYEE_SERVICE_DATA } from "@constants/employee-service-data";

import {
  InputTextAreaRow,
  InputTextRow,
  SelectControllerRow,
} from "@components";

import { AGREEMENT_FIELDS } from "../..";
import { useEmployeeServiceData } from "@hooks/useEmployeeServiceData";
import { getEmployeeServiceDataConvertForProcurement } from "@helpers/employeeServiceDataConvert";
import { useLanguage } from "@hooks/useLanguage";
import { useEffect } from "react";
import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

const GRADE_ID = 10;
export const ACCAuthorizePersonInfo = () => {
  const {
    register,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation();
  const { language } = useLanguage();

  const { data: commonInfoResponse } = useEmployeeServiceData({
    dataType: EMPLOYEE_SERVICE_DATA.COMMON_INFO,
    gradeId: GRADE_ID,
  });

  const watchPersonId = watch(AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_ID);

  useEffect(() => {
    if (watchPersonId) {
      const selectedPerson = commonInfoResponse?.commonInfo?.find(
        (item: EmployeeCommonInfoType) => item.id === watchPersonId,
      ) as EmployeeCommonInfoType;

      setValue(
        AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_EMAIL,
        selectedPerson?.email,
      );
      setValue(
        AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_PHONE_NUMBER,
        selectedPerson?.mobileNumber,
      );
      setValue(
        AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_DESIGNATION,
        selectedPerson?.positionName,
      );
      setValue(
        AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_NAME,
        selectedPerson?.nameEn,
      );
    }
  }, [watchPersonId, watch, setValue, commonInfoResponse]);

  return (
    <>
      <SectionHeader
        title={t("PROCUREMENT_CREATE.AGREEMENT.FORM.ACC_AUTHORIZED.TITLE")}
      />

      {/* <InputTextRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.ACC_AUTHORIZED.PERSON_NAME"
        register={{ ...register(AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_NAME) }}
      /> */}
      <SelectControllerRow
        control={control}
        register={{ ...register(AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_ID) }}
        setValue={setValue}
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.ACC_AUTHORIZED.PERSON_NAME"
        name={AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_ID}
        options={getEmployeeServiceDataConvertForProcurement(
          commonInfoResponse?.commonInfo || [],
          language,
        )}
      />

      <InputTextRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.ACC_AUTHORIZED.PERSON_EMAIL"
        register={{ ...register(AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_EMAIL) }}
        error={errors as any}
        required
        disabled
      />

      <InputTextRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.ACC_AUTHORIZED.PERSON_DESIGNATION"
        register={{
          ...register(AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_DESIGNATION),
        }}
        disabled
      />

      <InputTextRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.ACC_AUTHORIZED.PERSON_PHONE_NUMBER"
        register={{
          ...register(AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_PHONE_NUMBER),
        }}
        disabled
      />

      <InputTextAreaRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.ACC_AUTHORIZED.PERSON_DETAILS"
        register={{
          ...register(AGREEMENT_FIELDS.ACC_AUTHORIZED.PERSON_DETAILS),
        }}
      />
    </>
  );
};
